import React, { useEffect, useState } from "react";
import { ILinkedInvoice } from "../../interfaces/ILinkedInvoice";
import { TableCell, TableRow } from "@mui/material";
import { IInvoice } from "../../interfaces/IInvoice";
import { CustomeTextField } from "../core/CustomeTextField";

interface IProps {
    linkedInv: ILinkedInvoice;
    invoices: IInvoice[];
    linkedInvoices: ILinkedInvoice[];
    setLinkedInvoices: Function;
}


export const InvoiceLinkedRow:React.FC<IProps> = ({
    linkedInv,
    invoices,
    linkedInvoices,
    setLinkedInvoices
}) => {
    const [editLinkInv,setEditLinkInv] = useState(linkedInv);
    const currentInv = invoices.find(inv => inv.id === editLinkInv.ToInvoice);

    useEffect(() => {
        setLinkedInvoices([
            ...linkedInvoices.map(inv =>
                inv.ToInvoice === editLinkInv.ToInvoice ? editLinkInv : inv
            )
        ])
    },[editLinkInv])

    
    if (currentInv === undefined) {
        return(
            <TableRow>
                <TableCell colSpan={2}>
                    Kann Rechnung 
                </TableCell>
            </TableRow>
        )
    }

    return(
        <TableRow>
            <TableCell>
                {currentInv.invoice_number}
            </TableCell>
            <TableCell>
                {(currentInv.InvoiceType === 40) ?
                    <CustomeTextField
                        label="Zusatzleistung vom Kunden beauftragt"
                        attr="to_value_subtract"
                        object={editLinkInv}
                        setObject={setEditLinkInv}
                        type="boolean"
                    />
                    :
                    <CustomeTextField 
                        attr="positionTitle"
                        label="Positionstitel"
                        object={editLinkInv}
                        setObject={setEditLinkInv}
                        type="string"
                    />
                }

            </TableCell>
        </TableRow>
    )
}